import axios from "axios";
import Product from "../types/product";

export async function getFavourite() {
    try {
        const response = await axios.get(`/user/favourites/products`);
        const data = response.data;
        const favorites = data.data as { id: number; products: Product }[];

        // Extract product IDs for analytics
        const contentIds = favorites.map((item) => item.id);

        // --- Facebook Pixel: ViewContent (Wishlist)
        if (typeof fbq !== "undefined") {
            fbq("track", "ViewContent", {
                content_name: "Favorites Page",
                content_ids: contentIds,
                content_type: "product",
            });
        }

        // --- Snap Pixel: VIEW_CONTENT (Wishlist)
        if (typeof snaptr !== "undefined") {
            snaptr("track", "VIEW_CONTENT", {
                content_type: "product",
                content_ids: contentIds,
                content_name: "Favorites Page",
            });
        }

        // --- TikTok Pixel: ViewContent (Wishlist)
        // if (typeof ttq !== "undefined") {
        //     ttq("track", "ViewContent", {
        //         content_type: "product",
        //         content_ids: contentIds,
        //         content_name: "Favorites Page",
        //     });
        // }

        return data.data as { id: number; products: Product }[];
    } catch (error) {
        console.error(error);
    }
}
